@use "@fukuri-admins/ui/layout" as *;

.container {
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('lg');
}

.message {
  @include typography('Jp/16_W3');
  color: text('Low');
  text-align: center;
}
